// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"7a033615","46":"e64c9d61","114":"6ab360f8","246":"5109e6f2","791":"0a69e399","815":"ebdeefb8"}[chunkId] + ".js";
};